import { SVGIconComponent } from './types';

export const EventDoorJammed: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/event-door-jammed" stroke="none" fill="none">
      <path
        d="M5.47378386,4.00000172 C5.22144484,3.99913446 5,4.3264395 5,4.61118206 L5,19.6475095 C5,19.9730566 5.28839686,20.1015597 5.58364933,20.2309073 C8.43246098,21.4784451 14.1325013,23.9744315 14.1325013,23.9744315 C14.4277758,24.1037857 14.709295,23.7165808 14.709295,23.3910337 L14.709295,20.2586882 L17.1538018,20.2586882 C18.227561,20.2586882 19.1176471,19.3653673 19.1176471,18.279314 L19.1176471,5.99329028 C19.1176471,4.90723699 18.227561,4.00695977 17.1538018,4.00695977 C16.2302507,4.00695977 9.3678556,4.00348605 5.47378386,4.00000172 L5.47378386,4.00000172 Z M8.4950843,5.29876912 L17.1538018,5.29876912 C17.5426157,5.29876912 17.840461,5.60002462 17.840461,5.99329028 L17.840461,18.279314 C17.840461,18.6725796 17.5426157,18.966901 17.1538018,18.966901 L14.709295,18.966901 L14.709295,8.35461776 C14.709295,8.02907069 14.4277758,7.90056761 14.1325013,7.77121999 L8.4950843,5.29876912 Z"
        id="Fill-1"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
      <line x1="19.5" y1="3.5" x2="21.5" y2="1.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round"></line>
      <line x1="18.5" y1="2.5" x2="18.5" y2="0.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round"></line>
      <line x1="22.5" y1="4.5" x2="20.5" y2="4.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round"></line>
    </g>
  </svg>
);
